export const TOGGLE_MOBILE_MY_ACCOUNT_MENU = 'TOGGLE_MOBILE_MY_ACCOUNT_MENU';
export const SET_ADDRESS_LIST_LOADING = 'SET_ADDRESS_LIST_LOADING';
export const SET_ADDRESS_LIST_LOADED = 'SET_ADDRESS_LIST_LOADED';
export const SET_ADDRESS_LIST_LOAD_ERROR = 'SET_ADDRESS_LIST_LOAD_ERROR';
export const DELETE_ADDRESS = 'DELETE_ADDRESS';
